export default "__VITE_ASSET__BXeLNBtw__"